module.exports = __webpack_public_path__ + "img/learnReason-tableXl.afe86e2d.png";